import "../../styles/scss/resources.module.scss";
import { GetStaticProps } from "next";
import Layout from "../../components/layout";
import { useState } from "react";
import Link from "../../components/Link";
import CallToActionSmall from "../../components/v2/call-to-action-sm";
import AboutUsGallery from "../../components/v2/about-us-gallery";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import nextI18NextConfig from "../../next-i18next.config";
import '../../styles/scss/_events-page.module.scss';
import "../../styles/scss/blog.module.scss";

export default function EventPage() {
  const { t } = useTranslation('common');
  const eventsData = t('resources.events', { returnObjects: true, defaultValue: {} }) as any;

  const pageData = eventsData || {};
  const heroData = pageData?.hero || {};
  const upcomingSectionData = pageData?.upcomingSection || {};
  const pastSectionData = pageData?.pastSection || {};
  const allEvents = Array.isArray(pageData?.allEvents) ? pageData.allEvents : [];

  const pastEvents = allEvents.filter((event: any) => event?.isUpComing !== true);
  const [visibleCount, setVisibleCount] = useState(10);

  // Helper function to safely convert to string (handles objects)
  const safeString = (value: any): string => {
    if (value === null || value === undefined) return '';
    if (typeof value === 'string') return value;
    if (typeof value === 'object') {
      if (value.text) return String(value.text);
      if (value.value) return String(value.value);
      if (value.label) return String(value.label);
      return '';
    }
    return String(value);
  };

  const handleViewMore = () => {
    setVisibleCount((prev) => Math.min(prev + 10, pastEvents.length));
  };

  const imageSets = [
    ["/images/about-us/gallery/group-event.png", "/images/about-us/gallery/event-mum.png"],
    ["/images/about-us/gallery/aws-ahmedabad.png", "/images/about-us/gallery/panel-discuss.png"],
    ["/images/about-us/gallery/dine-devops.png", "/images/about-us/gallery/cloud-native.png"],
    ["/images/about-us/gallery/event-dubai.png", "/images/about-us/gallery/open-event.png"],
    ["/images/about-us/gallery/banglore-event.png", "/images/about-us/gallery/us-event.png"]
  ];

  return (
      <>
        <Layout
            isHomePage={false}
            pageTitle={String(pageData?.pageTitle ?? '')}
            ogImage={String(pageData?.ogImage ?? '')}
            uri={String(pageData?.uri ?? '')}
            metaTitle={String(pageData?.metaTitle ?? '')}
            metaDesc={String(pageData?.metaDesc ?? '')}
            metaRobotsNoindex={String(pageData?.metaRobotsNoindex ?? '')}
            metaRobotsNofollow={String(pageData?.metaRobotsNofollow ?? '')}
        >
          <div className={"middle-wrapper site-page whitepaper-main blog-v2 resources-page"}>
            <div className={"whitepaper-hero-section blog-hero"}>
              <div className={"whitepaper-search header-section event"}>
                <div className={"container"}>
                  <div className={"d-flex"}>
                    <div className={"left-block"}>
                      <h1>
                        <span className={"text-gradient"}>{safeString(heroData?.titleHighlight ?? '')}</span>
                        {safeString(heroData?.titleSuffix ?? '')}
                      </h1>
                      <p>{safeString(heroData?.description ?? '')}</p>
                    </div>
                  </div>

                  <div className={"image-slideshow"}>
                    <AboutUsGallery imageSets={imageSets}/>
                  </div>
                </div>

                <section className={"event-calender event-page"}>
                  <div className={"container"}>

                    <div className={'section-tag news'}>{String(upcomingSectionData?.sectionTag ?? '')}</div>

                    <div className={"event-list"}>
                      {
                        allEvents.map((event: any, index: number) => {
                          if (event?.isUpComing === true) {
                            return <div className={"d-flex"} key={index}>
                              <div className={"event-left"}>
                                <div className={`category product-update`}>{String(pageData?.categoryText ?? '')}</div>
                                <h3>{String(event?.title ?? '')}</h3>
                                <p className={"venue"}>{String(event?.location ?? '')}</p>
                              </div>
                              <div className={"event-right"}>
                                <div className={"btn-flex"}>
                                  <div className={"event-date"}>
                                    <p className={"date"}>{String(event?.date ?? '')}</p>
                                  </div>
                                  <div className={"event-button"}>
                                    <Link href={String(event?.uri ?? '')} className={"ahref-btn primary"}>{String(pageData?.readMoreText ?? '')}</Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          }
                        })
                      }
                    </div>

                  </div>
                </section>
              </div>
            </div>

            <section className={"main-resources-whitepaper event-page"}>
              <div className={"container"}>
                <div className={'section-tag news'}>{String(pastSectionData?.sectionTag ?? '')}</div>
                <div className={"d-flex"}>
                  <div className={"right-block"}>
                    <div className={"content"}>
                      <div className={"d-flex"}>
                        {pastEvents.slice(0, visibleCount).map((event: any, index: number) => {
                          return <div className={"inner-block"} key={index}>
                            <Link href={String(event?.uri ?? '')} itemProp="url">
                              <div className={"image-wrapper"}>
                                <img
                                    src={String(event?.featuredImage?.sourceUrl ?? '')}
                                    alt={String(event?.featuredImage?.altText ?? '')}
                                    width={"100%"}
                                    height={"93%"}
                                />
                              </div>
                            </Link>
                            <div className={"category knowledge"}>{String(pageData?.eventsCategoryText ?? '')}</div>
                            <Link href={String(event?.uri ?? '')} itemProp="url">
                              <h3 className={"font-inter"}>{String(event?.title ?? '')}</h3>
                            </Link>
                            <p className={"venue"}>{String(event?.location ?? '')}</p>
                            <p className={"date"}>{String(event?.date ?? '')}</p>
                          </div>
                        })}
                      </div>
                      {visibleCount < pastEvents.length && (
                          <div className={"button-shadow-view"}> <button className="view-more-btn" onClick={handleViewMore}>
                            {String(pageData?.viewMoreText ?? '')}
                          </button></div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <CallToActionSmall />
          </div>
        </Layout>
      </>
  );
}

export const getStaticProps: GetStaticProps = async (ctx) => {
  const translations = await serverSideTranslations(
    ctx?.locale ?? "en",
    ["common", "header", "footer"],
    nextI18NextConfig,
  );
  return {
    props: {
      ...translations,
      pageData: "",
      pageTitle:
          "Middleware Events",
      description:
          "Stay updated on Middleware's upcoming events, meetups, and industry gatherings. Connect with leaders, learn and network with our community.",
      ogImage: "/images/resources/event-page-og.png",
      uri: "/events/",
      metaTitle:
          "Middleware Events",
      metaDesc:
          "Stay updated on Middleware's upcoming events, meetups, and industry gatherings. Connect with leaders, learn and network with our community.",
      metaRobotsNoindex: "index",
      metaRobotsNofollow: "follow",
    },
  };
};

